import { bl_fi_mst_ecomsync_item_ext_RowClass, bl_fi_mst_ecomsync_item_hdr_RowClass, bl_fi_mst_ecomsync_item_line_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class FinancialEcomsyncItemContainerModel extends BaseContainerModel {
  bl_fi_mst_ecomsync_item_hdr: bl_fi_mst_ecomsync_item_hdr_RowClass = new bl_fi_mst_ecomsync_item_hdr_RowClass();
  bl_fi_mst_ecomsync_item_lines: bl_fi_mst_ecomsync_item_line_RowClass[] = [];
  bl_fi_mst_ecomsync_item_exts: bl_fi_mst_ecomsync_item_ext_RowClass[] = [];
}

